// extracted by mini-css-extract-plugin
export default {"suggestion":"_6f86fff9","suggestionTitle":"_4dfab619"};